// Matches any letter followed by an uppercase letter
const CAMEL_TO_SEPARATOR = /([a-z])([A-Z])/g;
/**
 * Capitalize the first letter of a string.
 * @util
 */
export function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
/**
 * Convert a string to a specific case format.
 * @util
 */
export function convertCase(str, options) {
    if (str.length === 0) {
        return '';
    }
    // First, convert any existing camelCase to space-separated words
    const words = str.replace(CAMEL_TO_SEPARATOR, (_match, p1, p2) => `${p1} ${p2}`).split(/[\s-_]+/);
    let result = '';
    for (let i = 0; i < words.length; i++) {
        let word = words[i];
        if (word.length === 0) {
            continue;
        }
        word = options.transformWord(word, i);
        if (i > 0) {
            result = options.joinWord(result, word, i);
        }
        else {
            result = word;
        }
    }
    return result;
}
/**
 * Convert a string to camelCase (e.g., "hello world" -> "helloWorld")
 * @util
 */
export function toCamelCase(str) {
    return convertCase(str, {
        transformWord: (word, index) => {
            if (index === 0) {
                return word.toLowerCase();
            }
            return capitalizeFirstLetter(word);
        },
        joinWord: (result, word) => result + word,
    });
}
/**
 * Convert a string to kebab-case (e.g., "hello world" -> "hello-world")
 * @util
 */
export function toKebabCase(str) {
    return convertCase(str, {
        transformWord: word => word.toLowerCase(),
        joinWord: (result, word) => `${result}-${word}`,
    });
}
/**
 * Convert a string to PascalCase (e.g., "hello world" -> "HelloWorld")
 * @util
 */
export function toPascalCase(str) {
    return convertCase(str, {
        transformWord: capitalizeFirstLetter,
        joinWord: (result, word) => result + word,
    });
}
/**
 * Convert a string to snake_case (e.g., "hello world" -> "hello_world")
 * @util
 */
export function toSnakeCase(str) {
    return convertCase(str, {
        transformWord: word => word.toLowerCase(),
        joinWord: (result, word) => `${result}_${word}`,
    });
}
/**
 * Convert a string to Title Case (e.g., "hello world" -> "Hello World")
 * @util
 */
export function toTitleCase(str) {
    return convertCase(str, {
        transformWord: capitalizeFirstLetter,
        joinWord: (result, word) => `${result} ${word}`,
    });
}
//# sourceMappingURL=caseUtils.js.map